import script from "./FlagIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlagIcon.vue?vue&type=script&setup=true&lang=ts"

import "./FlagIcon.vue?vue&type=style&index=0&id=ad2b1dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad2b1dee"]])

export default __exports__